import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-primary-500 md:text-9xl">
        404
      </span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        抱歉，您访问的页面不存在或已被移除，不妨返回首页继续浏览最新影视资源。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-900 transition-colors hover:border-primary-400 cursor-pointer"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}